<template>
  <div
    :class="{
      'radio-select_active': active,
      'radio-select-view-wrap': true,
    }"
    @click="showPicker"
  >
    <span v-if="value" class="radio-select-text">{{ valueShow }}</span>
    <span v-else class="radio-select-placeholder">{{ _placeholder }}</span>
    <Popup v-model="visible" class="radio-popup" :ratio="55" :title="title" @cancel="cancel">
      <div class="radio-popup-content">
        <RadioView v-model="tempValue" :options="options" @click="confirm" />
      </div>
    </Popup>
  </div>
</template>

<script>
import Popup from '../Popup'
import RadioView from '../Radio/RadioView.vue'

export default {
  components: {
    RadioView,
    Popup,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    options: {
      default: () => [],
    },
    // eslint-disable-next-line vue/require-default-prop, vue/require-prop-types
    placeholder: {},
    // eslint-disable-next-line vue/require-default-prop, vue/require-prop-types
    value: {},
    // eslint-disable-next-line vue/require-default-prop, vue/require-prop-types
    title: {},
  },
  data() {
    return {
      visible: false,
      active: false,
      tempValue: null,
    }
  },
  computed: {
    _placeholder() {
      return this.placeholder || ''
    },
    valueShow() {
      const { value = [] } = this
      const temp = this.options.find(el => el.value === value) || {}
      return temp.label
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.tempValue = newVal
        }
      },
    },
  },
  methods: {
    showPicker() {
      this.visible = true
      this.active = true
    },
    cancel() {
      this.visible = false
      this.active = false
      this.tempValue = this.value
    },
    confirm() {
      this.$emit('input', this.tempValue)
      this.$emit('change', this.tempValue)
      this.active = false
      this.visible = false
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
